var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWellies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.425 25.435a18.465 18.465 0 01-4.399-.546 11.907 11.907 0 005.13 1.11c4.253 0 5.416-1.598 5.728-2.755-.731 1.177-2.818 2.19-6.459 2.19zM8.924 26h3.654l.64-1.317H8.197c.002.684.06 1.316.728 1.316z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 22.25c-.05-.805-.675-1.446-1.459-1.5-.734 0-2.192.746-2.923.746-2.193 0-4.386-3-4.386-4.496 0-1.497.728-6.75.728-14.25 0 0-2.876-.75-5.113-.75C9.654 2 6 2.75 6 2.75c0 6.753 2.193 12 2.193 15.746 0 1.504-.734 2.253-.734 4.504 0 0 0 1.496.734 1.496h5.116c1.661.503 3.384.757 5.116.753 4.382 0 6.575-1.503 6.575-3zM9.654 4.813h2.924a.928.928 0 01.865.937.93.93 0 01-.865.937H9.654a.93.93 0 01-.864-.937c0-.499.38-.91.864-.937z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.654 6.497h2.924a.718.718 0 00.545-.203.761.761 0 000-1.092.718.718 0 00-.545-.202H9.654a.718.718 0 00-.545.202.761.761 0 000 1.092.718.718 0 00.545.203z"
  }))));
}

export default SvgWellies;